"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverDescNode = void 0;
const react_1 = __importDefault(require("react"));
const HoverDescNode_module_scss_1 = __importDefault(require("./HoverDescNode.module.scss"));
const md_1 = require("react-icons/md");
const HoverDescNode = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `${HoverDescNode_module_scss_1.default.HoverDesc}` },
            react_1.default.createElement(md_1.MdContactMail, null),
            react_1.default.createElement("div", { className: HoverDescNode_module_scss_1.default.description }, props.children))));
};
exports.HoverDescNode = HoverDescNode;
//# sourceMappingURL=HoverDescNode.js.map